import React, { useRef, useState } from "react";
import { postImage } from "service/api/burial";
import { ReactComponent as AddIcon } from "assets/bruial/addIcon.svg";
import { ReactComponent as SmallAddIcon } from "assets/bruial/smallAddIcon.svg";
import responseCodeConstant from "service/constant/responseCodeConstant";
import type { IBurialDetail } from "service/interface/burial";

interface Props {
  data: IBurialDetail;
  setData: React.Dispatch<React.SetStateAction<IBurialDetail>>;
}

export function ImgInfoTable({ data, setData }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files![0]) {
      const formData = new FormData();
      formData.append("image", e.target.files![0]);
      const imgRes = await postImage(formData);
      if (imgRes.status === responseCodeConstant.SUCCESS.ok) {
        setData((prev) => ({
          ...prev,
          Images: [...prev.Images, imgRes.data.data],
        }));
      }
    }
  };

  const handleAddBtn = () => {
    inputRef.current?.click();
  };

  const handleDeleteBtn = (idx: number) => {
    const dataCopiedArr = data.Images;

    dataCopiedArr.splice(idx, 1);

    setData((prev) => ({
      ...prev,
      Images: dataCopiedArr,
    }));
  };

  return (
    <div>
      <div className="mb-[16px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          추모공원 이미지 정보{" "}
          <span className="ml-[12px] text-[16px] text-gray-5">
            * 이미지 크기 100:72.43
          </span>
        </p>
        {data.Images?.length !== 0 && (
          <div
            className="flex cursor-pointer items-center gap-[4px]"
            onClick={handleAddBtn}
          >
            <SmallAddIcon />
            <p className="m-0 text-[18px] font-semibold text-black">추가하기</p>
          </div>
        )}
      </div>
      <input
        className="hidden"
        id="fileInput"
        type="file"
        accept="image/*"
        ref={inputRef}
        onChange={handleInputChange}
      />
      <div className="w-full border-t-[2px] border-t-black p-0">
        {data.Images.length !== 0 ? (
          <div className="mt-[24px] flex flex-col gap-[18px]">
            {data.Images.map((img, idx) => (
              <div
                key={idx}
                className="relative mx-auto flex w-[50%] justify-center"
              >
                <img
                  src={img.src}
                  alt="cover img"
                  className="aspect-[1.380645] w-full object-cover"
                />
                <div
                  onClick={() => handleDeleteBtn(idx)}
                  className="absolute right-[-10px] top-[-10px] flex h-[24px] w-[24px] cursor-pointer items-center justify-center rounded-full bg-gray-5 text-[14px] font-bold text-white"
                >
                  X
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            onClick={handleAddBtn}
            className="mt-[24px] flex h-[150px] w-full cursor-pointer flex-col items-center justify-center gap-[16px] rounded-[16px] border-[2px] border-dashed border-[#d1d1d1] bg-[#f8f8f8]"
          >
            <AddIcon />
            <p className="m-0 text-M3 font-semibold text-black">
              이미지 추가하기
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
